"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// Générateur de QR Code simple en SVG (sans dépendance externe)
const QRCodeSVG = ({
  value,
  size = 120,
  bgColor = '#ffffff',
  fgColor = '#000000'
}) => {
  // Utilisation d'une API gratuite pour générer le QR code
  const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(value)}&bgcolor=${bgColor.replace('#', '')}&color=${fgColor.replace('#', '')}`;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
    src: qrUrl,
    alt: "QR Code",
    style: {
      width: size,
      height: size,
      borderRadius: 8
    },
    loading: "lazy"
  });
};

// Configuration des plateformes
const PLATFORMS = {
  google: {
    name: 'Google',
    icon: '🔍',
    color: '#4285F4',
    bgColor: '#E8F0FE',
    urlTemplate: 'https://search.google.com/local/writereview?placeid='
  },
  tripadvisor: {
    name: 'TripAdvisor',
    icon: '🦉',
    color: '#00AF87',
    bgColor: '#E6F7F3',
    urlTemplate: 'https://www.tripadvisor.com/'
  },
  facebook: {
    name: 'Facebook',
    icon: '👍',
    color: '#1877F2',
    bgColor: '#E7F3FF',
    urlTemplate: 'https://www.facebook.com/'
  },
  yelp: {
    name: 'Yelp',
    icon: '⭐',
    color: '#D32323',
    bgColor: '#FCE8E8',
    urlTemplate: 'https://www.yelp.com/biz/'
  },
  ubereats: {
    name: 'Uber Eats',
    icon: '🍔',
    color: '#06C167',
    bgColor: '#E6F9EF',
    urlTemplate: 'https://www.ubereats.com/'
  },
  deliveroo: {
    name: 'Deliveroo',
    icon: '🚴',
    color: '#00CCBC',
    bgColor: '#E6FAF8',
    urlTemplate: 'https://deliveroo.fr/'
  },
  thefork: {
    name: 'TheFork',
    icon: '🍴',
    color: '#589442',
    bgColor: '#EEF5EB',
    urlTemplate: 'https://www.thefork.fr/'
  }
};

// Carte de plateforme
const PlatformCard = ({
  platform,
  url,
  displayMode,
  onClick,
  scaleFactor = 1,
  cardStyle = 'default'
}) => {
  const [isHovered, setIsHovered] = (0, _react.useState)(false);
  const platformConfig = PLATFORMS[platform] || PLATFORMS.google;
  const cardStyles = {
    default: {
      background: isHovered ? platformConfig.bgColor : '#fff',
      border: `2px solid ${platformConfig.color}40`,
      borderRadius: `calc(16px * ${scaleFactor})`,
      boxShadow: isHovered ? `0 8px 30px ${platformConfig.color}30` : '0 4px 15px rgba(0,0,0,0.08)'
    },
    minimal: {
      background: 'transparent',
      border: 'none',
      borderRadius: `calc(12px * ${scaleFactor})`,
      boxShadow: 'none'
    },
    gradient: {
      background: `linear-gradient(135deg, ${platformConfig.color}15, ${platformConfig.color}05)`,
      border: `2px solid ${platformConfig.color}30`,
      borderRadius: `calc(20px * ${scaleFactor})`,
      boxShadow: isHovered ? `0 12px 40px ${platformConfig.color}25` : '0 6px 20px rgba(0,0,0,0.1)'
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    onClick: () => displayMode === 'link' && onClick && onClick(url),
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    style: {
      ...(cardStyles[cardStyle] || cardStyles.default),
      padding: `calc(1.25rem * ${scaleFactor})`,
      cursor: displayMode === 'link' ? 'pointer' : 'default',
      transition: 'all 0.3s ease',
      transform: isHovered ? 'translateY(-4px)' : 'translateY(0)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: `calc(0.75rem * ${scaleFactor})`,
      minWidth: `calc(180px * ${scaleFactor})`,
      flex: '1 1 auto'
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        fontSize: `calc(2.5rem * ${scaleFactor})`,
        width: `calc(70px * ${scaleFactor})`,
        height: `calc(70px * ${scaleFactor})`,
        borderRadius: '50%',
        background: platformConfig.bgColor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: `0 4px 15px ${platformConfig.color}20`
      },
      children: platformConfig.icon
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        fontSize: `calc(1.1rem * ${scaleFactor})`,
        fontWeight: '600',
        color: platformConfig.color
      },
      children: platformConfig.name
    }), displayMode === 'qrcode' && url && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        background: '#fff',
        padding: `calc(0.5rem * ${scaleFactor})`,
        borderRadius: `calc(12px * ${scaleFactor})`,
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(QRCodeSVG, {
        value: url,
        size: Math.round(100 * scaleFactor),
        fgColor: platformConfig.color
      })
    }), displayMode === 'link' && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        background: platformConfig.color,
        color: '#fff',
        padding: `calc(0.6rem * ${scaleFactor}) calc(1.2rem * ${scaleFactor})`,
        borderRadius: `calc(25px * ${scaleFactor})`,
        fontSize: `calc(0.85rem * ${scaleFactor})`,
        fontWeight: '600',
        boxShadow: `0 4px 15px ${platformConfig.color}40`,
        transition: 'transform 0.2s ease',
        transform: isHovered ? 'scale(1.05)' : 'scale(1)'
      },
      children: "Donner mon avis \u2192"
    })]
  });
};

// Composant principal
const ReviewCell = ({
  // Titre et message
  title = 'Votre avis compte !',
  subtitle = 'Aidez-nous à nous améliorer en partageant votre expérience',
  thank_you_message = 'Merci pour votre soutien ! 💖',
  // Plateformes configurées (chaque plateforme peut avoir son propre display_mode)
  // display_mode: 'qrcode' ou 'link'
  platforms: platformsProp = [],
  // Style
  template_name = 'default',
  styles_properties = {},
  // Layout
  layout = 'grid',
  // 'grid', 'horizontal', 'vertical'

  ...rest
}) => {
  const containerRef = (0, _react.useRef)(null);
  const [scaleFactor, setScaleFactor] = (0, _react.useState)(1);

  // S'assurer que platforms est toujours un tableau
  const platforms = Array.isArray(platformsProp) ? platformsProp : [];

  // Calcul du scale factor
  (0, _react.useEffect)(() => {
    if (!containerRef.current) return;
    const updateScale = () => {
      const width = containerRef.current.offsetWidth;
      const baseWidth = 800;
      setScaleFactor(Math.max(0.6, Math.min(1.5, width / baseWidth)));
    };
    updateScale();
    const observer = new ResizeObserver(updateScale);
    observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  // Normalisation des props
  const {
    primaryColor = '#FF6B6B',
    secondaryColor = '#4ECDC4',
    accentColor = '#FFE66D',
    backgroundColor = '#FAFAFA',
    textColor = '#333333',
    fontFamily = '"Poppins", "Segoe UI", sans-serif',
    cardStyle = 'default',
    showThankYou = true
  } = styles_properties;

  // Gérer le clic sur une plateforme
  const handlePlatformClick = url => {
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  // Styles selon le template
  const getTemplateStyles = () => {
    switch (template_name) {
      case 'modern':
        return {
          container: {
            background: `linear-gradient(180deg, ${backgroundColor} 0%, ${primaryColor}10 100%)`
          },
          title: {
            background: `linear-gradient(135deg, ${primaryColor}, ${secondaryColor})`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }
        };
      case 'elegant':
        return {
          container: {
            background: `radial-gradient(ellipse at top, ${accentColor}20, ${backgroundColor})`
          },
          title: {
            color: secondaryColor,
            fontStyle: 'italic'
          }
        };
      case 'playful':
        return {
          container: {
            background: `linear-gradient(135deg, ${primaryColor}15, ${secondaryColor}15, ${accentColor}15)`
          },
          title: {
            color: primaryColor
          }
        };
      default:
        return {
          container: {
            background: backgroundColor
          },
          title: {
            color: textColor
          }
        };
    }
  };
  const templateStyles = getTemplateStyles();

  // Layout styles
  const getLayoutStyles = () => {
    switch (layout) {
      case 'horizontal':
        return {
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'nowrap',
          overflowX: 'auto',
          gap: `calc(1rem * ${scaleFactor})`,
          padding: `calc(1rem * ${scaleFactor})`,
          WebkitOverflowScrolling: 'touch'
        };
      case 'vertical':
        return {
          display: 'flex',
          flexDirection: 'column',
          gap: `calc(1rem * ${scaleFactor})`,
          overflowY: 'auto',
          padding: `calc(1rem * ${scaleFactor})`
        };
      default:
        // grid
        return {
          display: 'grid',
          gridTemplateColumns: `repeat(auto-fit, minmax(calc(200px * ${scaleFactor}), 1fr))`,
          gap: `calc(1.5rem * ${scaleFactor})`,
          padding: `calc(1rem * ${scaleFactor})`
        };
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ref: containerRef,
    style: {
      fontFamily,
      height: '100%',
      padding: `calc(1.5rem * ${scaleFactor})`,
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      ...templateStyles.container
    },
    ...rest,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("header", {
      style: {
        textAlign: 'center',
        marginBottom: `calc(1.5rem * ${scaleFactor})`
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
        style: {
          fontSize: `calc(2rem * ${scaleFactor})`,
          fontWeight: '700',
          margin: 0,
          marginBottom: `calc(0.5rem * ${scaleFactor})`,
          ...templateStyles.title
        },
        children: title
      }), subtitle && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        style: {
          fontSize: `calc(1rem * ${scaleFactor})`,
          color: textColor,
          opacity: 0.7,
          margin: 0,
          maxWidth: '500px',
          marginLeft: 'auto',
          marginRight: 'auto'
        },
        children: subtitle
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        flex: 1,
        overflow: 'auto'
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: getLayoutStyles(),
        children: platforms.map((p, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(PlatformCard, {
          platform: p.platform,
          url: p.url,
          displayMode: p.display_mode || 'qrcode',
          onClick: handlePlatformClick,
          scaleFactor: scaleFactor,
          cardStyle: cardStyle
        }, p.platform + index))
      })
    }), showThankYou && thank_you_message && /*#__PURE__*/(0, _jsxRuntime.jsx)("footer", {
      style: {
        textAlign: 'center',
        marginTop: `calc(1.5rem * ${scaleFactor})`,
        padding: `calc(1rem * ${scaleFactor})`,
        background: `linear-gradient(135deg, ${primaryColor}10, ${secondaryColor}10)`,
        borderRadius: `calc(12px * ${scaleFactor})`
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        style: {
          fontSize: `calc(1.1rem * ${scaleFactor})`,
          fontWeight: '500',
          color: textColor,
          margin: 0
        },
        children: thank_you_message
      })
    })]
  });
};
var _default = exports.default = ReviewCell;